import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const VideoViewer = ({ url }) => {
    // console.log('url', url);
    const [playing, setPlaying] = useState(false)
  return (
    <div style={{}}>
      <ReactPlayer
        url={url}
        playing={playing}
        config={{
          youtube: {
            playerVars: { showinfo: 1 },
          },
          facebook: {
            appId: '12345',
          },
          
        }}
        width='320px'
        height='200px'
        controls={true}
      />
    </div>
  );
};

export default VideoViewer;
